import { USE_SLIDE_VIEW } from './alertListDetail.define';
import { RouteInfo, SlideViewType, StoredAlertParams } from './alertListDetail.types';

// 키/타입 정규화 유틸
export const normalizeType = (raw: SlideViewType | Partial<RouteInfo>['type']) => {
  const rawStr = String(raw ?? '');
  const match = (Object.values(USE_SLIDE_VIEW) as string[]).find(
    (v) => v.toLowerCase() === rawStr.toLowerCase(),
  );

  return (match ?? USE_SLIDE_VIEW.DASHBOARD) as SlideViewType;
};

export const normalizeStoredKeys = (obj: StoredAlertParams): Partial<RouteInfo> => {
  if (!obj || typeof obj !== 'object') return {};

  const result: Partial<RouteInfo> = {};
  const canonicalKeys = Object.values(USE_SLIDE_VIEW) as string[];

  Object.entries(obj).forEach(([k, v]) => {
    const canonical = canonicalKeys.find((ck) => ck.toLowerCase() === String(k).toLowerCase());
    // 알려진 뷰 키는 정규화(예: objecttopology -> objectTopology), 그 외는 그대로 보존
    result[canonical ?? k] = v;
  });

  return result;
};
